module.exports = __webpack_public_path__ + "img/saturnina.89d36167.png";